// extracted by mini-css-extract-plugin
module.exports = {"faqSection":"FAQSection_faqSection__6CaKY"};